<nz-spin [nzSpinning]="loading$ | async">
  <form
    *ngIf="(loading$ | async) === false"
    nz-form
    class="form"
    nzLayout="horizontal"
    [formGroup]="form">
    <div class="drawer-form-wrapper">
      <div class="behaviour-card-sec" *ngIf="!!caseParams.case">
        <div class="header-with-cta mb-24">
          <h3 class="title s-18">
            {{ caseParams.case.student.firstName }}
            {{ caseParams.case.student.lastName }}
          </h3>
        </div>
        <div class="card-content-wrapper">
          <div class="content">
            <h4 class="title">Date Of Birth</h4>
            <p class="desc">
              <svg-icon
                src="/assets/icon/icon-calendar.svg"
                class="icon s-16"
                aria-label="Calendar"></svg-icon>
              {{ caseParams.case.student.dateOfBirth | date: 'MM/dd/yyyy' }}
            </p>
          </div>
          <div class="content">
            <h4 class="title">Supervisor</h4>
            <p class="desc">
              <svg-icon
                src="/assets/icon/icon-supervisor.svg"
                class="icon s-16"
                aria-label="Supervisor"></svg-icon>
              {{ caseParams.case.supervisorName }}
            </p>
          </div>
          <div class="content">
            <h4 class="title">Gender</h4>
            <p class="desc">
              <svg-icon
                src="/assets/icon/icon-male.svg"
                class="icon s-18"
                aria-label="Male"></svg-icon>
              {{ caseParams.case.student.gender }}
            </p>
          </div>
        </div>
      </div>

      <ng-container *ngIf="currentStep">
        <ng-container
          *ngTemplateOutlet="stepHeader; context: { step: currentStep }">
        </ng-container>

        <ng-container [ngSwitch]="currentStep.kind">
          <div *ngSwitchCase="WizardStepKind.BehaviorCategory">
            <nz-form-item>
              <nz-form-control>
                <div class="radio-wrapper">
                  <nz-radio-group
                    id="behaviorCategory"
                    nzName="behaviorCategory"
                    formControlName="behaviorCategoryId">
                    <span
                      nz-radio
                      *ngFor="
                        let cat of behaviorCategoryList;
                        trackBy: trackById
                      "
                      [nzValue]="cat.id"
                      class="box-radio">
                      {{ cat.name }}
                    </span>
                  </nz-radio-group>
                </div>
                <div
                  class="ant-form-item-explain-error mt-3"
                  *ngIf="form.get('behaviorCategoryId')?.hasError('required')">
                  Please select category.
                </div>
              </nz-form-control>
            </nz-form-item>
          </div>

          <div
            *ngSwitchCase="WizardStepKind.NativeField"
            [ngSwitch]="currentStep.refId">
            <ng-container *ngSwitchCase="lookupIds.CaseBehaviorTypes">
              <app-define-behavior-wizard-behavior-types-step
                [form]="form"
                [isRequired]="currentStep.isRequired"
                [categoryName]="
                  getCategoryNameById(form.get('behaviorCategoryId')?.value)
                "
                [behaviourSubCategoryList]="behaviourSubCategoryList"
                [behaviorTypeDescriptionControls]="
                  behaviorTypeDescriptionControls
                "
                [onCheckboxChange]="onCheckboxChange"
                [onBehaviorTypeChange]="onBehaviorTypeChange"
                [onControlInputChange]="onControlInputChange"
                [getBehaviorTypeDescriptionTitle]="
                  getBehaviorTypeDescriptionTitle
                "
                [trackById]="trackById"
                [trackByIndex]="trackByIndex"
                (openFunctionalEquivalent)="
                  isFunctionalEquivalentModalVisible = true
                ">
              </app-define-behavior-wizard-behavior-types-step>
            </ng-container>

            <ng-container *ngSwitchCase="lookupIds.OperationalDefinition">
              <app-define-behavior-wizard-operational-definition-step
                [form]="form"
                [isRequired]="currentStep.isRequired"
                [onControlInputChange]="onControlInputChange"
                (openPdfModal)="openPdfModal()">
              </app-define-behavior-wizard-operational-definition-step>
            </ng-container>

            <ng-container *ngSwitchCase="lookupIds.Frequency">
              <app-define-behavior-wizard-frequency-step
                [form]="form"
                [isRequired]="currentStep.isRequired"
                [behaviourFrequencyList]="behaviourFrequencyList"
                [getBehaviorFrequencyLabel]="getBehaviorFrequencyLabel"
                [trackById]="trackById">
              </app-define-behavior-wizard-frequency-step>
            </ng-container>

            <ng-container *ngSwitchCase="lookupIds.Intensity">
              <app-define-behavior-wizard-intensity-step
                [form]="form"
                [isRequired]="currentStep.isRequired"
                [behaviourIntensityList]="behaviourIntensityList"
                [showWarningModal]="showWarningModal"
                [handleKeyDown]="handleKeyDown"
                [trackById]="trackById">
              </app-define-behavior-wizard-intensity-step>
            </ng-container>

            <ng-container *ngSwitchCase="lookupIds.Environmnets">
              <app-define-behavior-wizard-environments-step
                [form]="form"
                [isRequired]="currentStep.isRequired"
                [behaviourEnvironmentList]="behaviourEnvironmentList"
                [onCheckboxChange]="onCheckboxChange"
                [trackById]="trackById">
              </app-define-behavior-wizard-environments-step>
            </ng-container>

            <ng-container *ngSwitchCase="lookupIds.SettingEvents">
              <app-define-behavior-wizard-setting-events-step
                [form]="form"
                [isRequired]="currentStep.isRequired"
                [behaviourSettingEventList]="behaviourSettingEventList"
                [onCheckboxChange]="onCheckboxChange"
                [trackById]="trackById"
                (openSettingEvents)="isSettingEventModalVisible = true">
              </app-define-behavior-wizard-setting-events-step>
            </ng-container>

            <ng-container *ngSwitchCase="lookupIds.Antecedents">
              <app-define-behavior-wizard-antecedents-step
                [form]="form"
                [isRequired]="currentStep.isRequired"
                [behaviourAntecedentList]="behaviourAntecedentList"
                [antecedentDescriptionControls]="antecedentDescriptionControls"
                [onCheckboxChange]="onCheckboxChange"
                [onAntecedentChange]="onAntecedentChange"
                [onControlInputChange]="onControlInputChange"
                [getBehaviorAntecedentTitle]="getBehaviorAntecedentTitle"
                [trackById]="trackById"
                [trackByIndex]="trackByIndex">
              </app-define-behavior-wizard-antecedents-step>
            </ng-container>

            <ng-container *ngSwitchCase="lookupIds.Consequences">
              <app-define-behavior-wizard-consequences-step
                [form]="form"
                [isRequired]="currentStep.isRequired"
                [behaviorConsequenceList]="behaviorConsequenceList"
                [consequenceDescriptionControls]="
                  consequenceDescriptionControls
                "
                [onCheckboxChange]="onCheckboxChange"
                [onConsequenceChange]="onConsequenceChange"
                [onControlInputChange]="onControlInputChange"
                [getBehaviorConsequenceTitle]="getBehaviorConsequenceTitle"
                [trackById]="trackById"
                [trackByIndex]="trackByIndex">
              </app-define-behavior-wizard-consequences-step>
            </ng-container>

            <ng-container *ngSwitchCase="lookupIds.Goals">
              <app-define-behavior-wizard-goals-step
                [form]="form"
                [isRequired]="currentStep.isRequired"
                [behaviorGoal]="behaviorGoal"
                [getBehaviorGoalLabel]="getBehaviorGoalLabel"
                [onControlInputChange]="onControlInputChange"
                (openExampleOfGoals)="openExampleOfGoals()">
              </app-define-behavior-wizard-goals-step>
            </ng-container>
          </div>

          <div *ngSwitchCase="WizardStepKind.EmbeddedCustomQuestion">
            <ng-container
              *ngTemplateOutlet="
                customQuestionAnswer;
                context: {
                  questionId: currentStep.refId,
                  required: currentStep.isRequired,
                }
              ">
            </ng-container>
          </div>

          <div *ngSwitchCase="WizardStepKind.CustomQuestionBundle">
            <ng-container *ngIf="currentStep.questionIds.length === 0">
              <p class="form-desc">No questions available.</p>
            </ng-container>
            <ng-container
              *ngFor="
                let questionId of currentStep.questionIds;
                trackBy: trackByIndex
              ">
              <ng-container
                *ngTemplateOutlet="
                  customQuestionAnswer;
                  context: {
                    questionId: questionId,
                    required:
                      currentStep.questionGating[questionId]?.isRequired,
                    isHardStop:
                      currentStep.questionGating[questionId]?.isHardStop,
                    helpText: currentStep.questionGating[questionId]?.helpText,
                  }
                ">
              </ng-container>
            </ng-container>
          </div>

          <div *ngSwitchCase="WizardStepKind.Summary">
            <app-define-behavior-wizard-summary
              [sections]="summarySections"
              [allowManageBehavior]="allowManageBehavior"
              [isDraft]="isBehaviorDraft"
              [pendingHardStopNames]="pendingHardStopNames"
              [pendingRequiredNames]="pendingRequiredNames"
              (editStep)="redirectToStep($event)">
            </app-define-behavior-wizard-summary>
          </div>
        </ng-container>
      </ng-container>
    </div>

    <div class="display-flex justify-content-between drawer-footer">
      <div class="footer-left">
        <button
          nz-button
          type="button"
          nzType="default"
          (click)="closeDrawer()">
          Cancel
        </button>
        <button
          *ngIf="allowManageBehavior && !isLastStep"
          nz-button
          type="button"
          nzType="default"
          [nzLoading]="isSaving"
          [disabled]="isActionInProgress || !form.get('caseId')?.value"
          (click)="onSaveForLater()">
          Save for Later
        </button>
      </div>
      <div class="footer-right" *ngIf="allowManageBehavior">
        <button
          nz-button
          type="button"
          nzType="default"
          [disabled]="currentIndex === 0"
          (click)="onPrevious()">
          Previous
        </button>
        <button
          *ngIf="!isLastStep"
          nz-button
          type="button"
          nzType="primary"
          [nzLoading]="isSaving"
          [disabled]="isActionInProgress || !canProceed"
          (click)="onNext()">
          Save & Next
        </button>
        <button
          *ngIf="!isLastStep && cameFromSummary"
          nz-button
          type="button"
          nzType="default"
          [nzLoading]="isSaving"
          [disabled]="isActionInProgress || !canProceed"
          (click)="onSaveAndPreview()">
          Save & Preview
        </button>
        <button
          *ngIf="isLastStep"
          nz-button
          type="button"
          nzType="primary"
          [nzLoading]="isSaving"
          [disabled]="isActionInProgress || !canProceed || hasPendingValidation"
          (click)="onFinish()">
          Save & Close
        </button>
        <button
          *ngIf="isLastStep && nextContinueTile"
          nz-button
          type="button"
          nzType="primary"
          class="ml-8"
          [nzLoading]="isSaving"
          [disabled]="isActionInProgress || !canProceed || hasPendingValidation"
          (click)="onContinue()">
          Continue to&nbsp;
          <ng-container [ngSwitch]="nextContinueTile">
            <ng-container *ngSwitchCase="tileSection.Assessment">{{
              assessmentLabel | reportLabel | async
            }}</ng-container>
            <ng-container *ngSwitchCase="tileSection.Strategy"
              >Strategy</ng-container
            >
            <ng-container *ngSwitchDefault>Data</ng-container>
          </ng-container>
        </button>
      </div>
    </div>
  </form>
</nz-spin>

<ng-template #stepHeader let-step="step">
  <div class="header-with-cta mb-24">
    <div class="quetion-badge">
      <span class="badge">{{ currentIndex + 1 }}/{{ steps.length }}</span>
      <h3 class="title s-18">{{ step.label }}</h3>
      <span
        class="wizard-step__badge wizard-step__badge--hard-stop"
        nz-tooltip
        nzTooltipTitle="User cannot proceed to the next step until this is filled"
        *ngIf="step.isHardStop">
        Hard Stop
      </span>
      <span
        class="wizard-step__badge wizard-step__badge--required"
        nz-tooltip
        nzTooltipTitle="Must be filled before the plan can be completed"
        *ngIf="!step.isHardStop && step.isRequired">
        Required
      </span>
      <ng-container *ngIf="step.helpText">
        <span class="wizard-step__help-separator">|</span>
        <span
          class="wizard-step__help"
          nz-tooltip
          [nzTooltipTitle]="step.helpText"
          [nzTooltipTrigger]="
            isHelpTextTruncated(step.helpText) ? 'hover' : null
          ">
          {{ step.helpText | truncate }}
        </span>
      </ng-container>
    </div>
    <button
      *ngIf="step.kind === WizardStepKind.Summary"
      nz-button
      type="button"
      nzType="default"
      [nzLoading]="isPrintLoading"
      (click)="print()">
      <svg-icon
        src="/assets/icon/icon-printer.svg"
        class="icon s-20"
        aria-label="Printer"></svg-icon>
      Download
    </button>
  </div>
</ng-template>

<ng-template
  #customQuestionAnswer
  let-questionId="questionId"
  let-required="required"
  let-isHardStop="isHardStop"
  let-helpText="helpText">
  <ng-container
    *ngIf="answerControlAt(questionId) as group"
    [formGroup]="group">
    <nz-form-item>
      <nz-form-label
        [nzFor]="'question' + questionId"
        [nzRequired]="!!required">
        <div class="quetion-badge">
          <p class="form-desc">{{ questionLabel(questionId) }}</p>
          <span
            class="wizard-step__badge wizard-step__badge--hard-stop"
            nz-tooltip
            nzTooltipTitle="User cannot proceed to the next step until this is filled"
            *ngIf="isHardStop">
            Hard Stop
          </span>
          <span
            class="wizard-step__badge wizard-step__badge--required"
            nz-tooltip
            nzTooltipTitle="Must be filled before the plan can be completed"
            *ngIf="!isHardStop && required">
            Required
          </span>
          <ng-container *ngIf="helpText">
            <span class="wizard-step__help-separator">|</span>
            <span
              class="wizard-step__help"
              nz-tooltip
              [nzTooltipTitle]="helpText"
              [nzTooltipTrigger]="
                isHelpTextTruncated(helpText) ? 'hover' : null
              ">
              {{ helpText | truncate }}
            </span>
          </ng-container>
        </div>
      </nz-form-label>
      <nz-form-control>
        <textarea
          [id]="'question' + questionId"
          name="answer"
          [attr.aria-label]="questionLabel(questionId)"
          formControlName="answer"
          rows="2"
          nz-input
          placeholder="Enter your answer"
          (input)="
            onControlInputChange($event, group.get('answer'))
          "></textarea>
      </nz-form-control>
      <div
        class="ant-form-item-explain-error mt-3"
        *ngIf="group.get('answer')?.errors?.['required']">
        Please enter your answer.
      </div>
    </nz-form-item>
  </ng-container>
</ng-template>

<app-define-behavior-wizard-info-modals
  [isWarningModalVisible]="isWarningModalVisible"
  [isFunctionalEquivalentModalVisible]="isFunctionalEquivalentModalVisible"
  [isSettingEventModalVisible]="isSettingEventModalVisible"
  [isGoalExampleModalVisible]="isGoalExampleModalVisible"
  [isPdfModalVisible]="isPdfModalVisible"
  [behaviorGoalExamples]="behaviorGoalExamples"
  [trackByGoal]="trackByGoal"
  (warningCancel)="handleWarningOk()"
  (functionalEquivalentVisibleChange)="
    isFunctionalEquivalentModalVisible = $event
  "
  (settingEventVisibleChange)="isSettingEventModalVisible = $event"
  (goalExampleVisibleChange)="isGoalExampleModalVisible = $event"
  (pdfVisibleChange)="isPdfModalVisible = $event">
</app-define-behavior-wizard-info-modals>

<ng-template #drawerFBATitleTpl>
  <app-drawer-header
    [title]="'Behavior Screener'"
    [subtitle]="'Assessment FBA'"
    [breadcrumbText]="(caseParams.case.student.firstName || '') + '\'' + 's'"
    (drawerClose)="closeAssessmentFbaDrawer()">
  </app-drawer-header>
</ng-template>
<ng-template #drawerTitleBehaviorStrategies>
  <app-drawer-header
    [title]="'Manage Behavior Strategies'"
    [subtitle]="'Strategies'"
    [breadcrumbText]="(caseParams.case.student.firstName || '') + '\'' + 's'"
    (drawerClose)="closeManageBehaviorStrategiesDrawer()">
  </app-drawer-header>
</ng-template>
<ng-template #drawerTitleData>
  <app-drawer-header
    [title]="'Data'"
    subtitle=""
    [breadcrumbText]="''"
    (drawerClose)="closeDataDrawer()">
  </app-drawer-header>
</ng-template>
